const menu = document.querySelector('.header .menus_wrapper')
const menuBurger = document.querySelector('.header .menu_btn_burger')

if (menu && menuBurger) {
  menuBurger.onclick = (e) => {
    e.preventDefault()

    toggleMenu()
  }
}

const responsiveWrapper = document.querySelector('#primary_navigation');
const menuBottom = document.querySelector('#menu-menu_bottom');

const defaultMenuBottomWrapper = document.querySelector('#bottom_navigation');

function addMenuBottomToDefaultResponsiveWrapper() {
  responsiveWrapper.insertAdjacentElement('beforeend', menuBottom);
}
function resetMenuBottom() {
  defaultMenuBottomWrapper.appendChild(menuBottom);
}

const mediaQuery = '(max-width: 1060px)';
const mediaQueryList = window.matchMedia(mediaQuery);

mediaQueryList.addEventListener('change', event => {
  if (event.matches) {
    addMenuBottomToDefaultResponsiveWrapper();
    toggleSubMenu();
  } else {
    resetMenuBottom();
  }
})

if (mediaQueryList.matches) {
  addMenuBottomToDefaultResponsiveWrapper();
  toggleSubMenu();
} else {
  resetMenuBottom();
}



function toggleSubMenu() {
  window.addEventListener('click', e => {
    if (e.target.parentNode.classList.contains('menu-item-has-children')) {
      document.querySelectorAll('.sub-menu').forEach(item => item.style.display = 'none');
      e.target.parentNode.querySelector('.sub-menu').style.display = 'block';
    } else {
      document.querySelectorAll('.sub-menu').forEach(item => item.style.display = 'none');
    }
  })
}


const openMenu = () => {
  menuBurger.classList.add('open')
  menu.classList.add('open')
  window.document.body.classList.add('responsive_menu_open')
}

const closeMenu = () => {
  menuBurger.classList.remove('open')
  menu.classList.remove('open')
  window.document.body.classList.remove('responsive_menu_open')

}

const toggleMenu = () => {
  if (menuBurger.classList.contains('open')) {
    closeMenu()
  } else {
    openMenu()
  }
}

// function removeFooterMenuTitlesHref() {
//   const elements = document.querySelectorAll('#footer_navigation #menu-menu_bottom-1 > li > a');

//   elements.forEach(el => {
//     el.removeAttribute('href');
//   })
// }

// removeFooterMenuTitlesHref();



// WEBPACK FOOTER //
// ./scripts/menu.js